import { render, staticRenderFns } from "./actBanner.vue?vue&type=template&id=0ebd28de&scoped=true&"
import script from "./actBanner.vue?vue&type=script&lang=js&"
export * from "./actBanner.vue?vue&type=script&lang=js&"
import style0 from "./actBanner.vue?vue&type=style&index=0&id=0ebd28de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebd28de",
  null
  
)

export default component.exports